import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AnalyticsEvent } from '../../models/analytics-event.interface';
import { SkyClubTrackerMultipleCardsMocks } from './mocks/skyclub.mocks';
import { SkyClubSpendTracker } from './models/skyclub.interfaces';
import { SkyclubSpendTrackerCardComponent } from './skyclub-spend-tracker-card/skyclub-spend-tracker-card.component';

@Component({
  selector: 'idp-skyclub-spend-tracker',
  standalone: true,
  imports: [CommonModule, SkyclubSpendTrackerCardComponent],
  templateUrl: './skyclub-spend-tracker.component.html',
  styleUrls: ['./skyclub-spend-tracker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SkyclubSpendTrackerComponent {
  @Input() content: SkyClubSpendTracker =
    SkyClubTrackerMultipleCardsMocks as SkyClubSpendTracker;

  @Output() skyclubTrackerClick = new EventEmitter<AnalyticsEvent>();

  carouselIndex = 0;

  previous(): void {
    this.carouselIndex--;
  }

  next(): void {
    this.carouselIndex++;
  }
}
